import React from 'react';
import IconBase, { iconPropTypes } from '../IconBase';

export default function InfraredScanningIcon(props) {
	return (
		<IconBase type="infrared-scanning" {...props}>
			<path d="M13 5H11V9.5H13V5Z" />
			<path d="M10 6H8V9.5H10V6Z" />
			<path d="M14 7H16V9.5H14V7Z" />
			<path d="M6 2C5.44772 2 5 2.44771 5 3H4.5C4.22386 3 4 3.22386 4 3.5V10.5C4 10.7761 4.22386 11 4.5 11H5V12C5 12.5523 5.44772 13 6 13H10.3913L10.0869 20.0019C10.0395 21.0911 10.9098 22 12 22C13.0902 22 13.9605 21.0911 13.9131 20.0019L13.6087 13H18C18.5523 13 19 12.5523 19 12V11H19.5C19.7761 11 20 10.7761 20 10.5V3.5C20 3.22386 19.7761 3 19.5 3H19C19 2.44772 18.5523 2 18 2H6ZM6.5 3.5H17.5V10.5H6.5V3.5Z" />
		</IconBase>
	);
}
InfraredScanningIcon.propTypes = iconPropTypes;
